import axios from 'axios';
import {getToken,getSToken} from '../utils/token'

export default class NofeshService {


    getHotelsWithPromise() {

      var promise = new Promise(function(resolve, reject) {
        setTimeout(() => {
          resolve(              
            [
              {key:1, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:2, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:3, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:4, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:5, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:6, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:7, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:8, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:9, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
              {key:10, name:'בראשית', cityPlace:'אילת', daysAndNightsPeriod:'2 לילות' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' }
            ]                             
          );
        },5000);
      });
      return promise;
    } 





    getSearchResulstHotelsList(searchObj) {

     return this.getHotelsWithPromise(); 
    }



    /*
    getPersonDataMock() {
      return {
        data : { 
          EmployeeCardNum : 1234,

          EmployeeIdNum :'303111222',

          first_name : 'ישראל',

          last_name: 'ישראלי',        

          num_family_adulds : 2,

          mobile_phone : '0522276401',

          NumChildEntitled : 3,

          NumberOfRooms : 3,


          hasEntitlementsNotOrdered:1,

          personsChildren : [ 
              {key:1,name:'גיל',   age:17, sex:1, child_type:1, selected:true},
              {key:2,name: 'מאיה', age:11, sex:2, child_type:1, selected:true},
              {key:3,name: 'מאור', age:3,  sex:1, child_type:2, selected:true}],


          personsMessages : [ 
              {key:1, title:' עדיין לא ניצלת את חופשת 2021', content:' עדיין לא ניצלת את החופשה לשנת 2021. תוכלי לנצל את החופשה בחודשיים הקרובים בלבד. לאחר חודשיים תאבדי את הזכאות לחופשה'},
              {key:2, title:'סתיו, עדיין לא ניצלת את חופשת 2021', content:' עדיין לא ניצלת את החופשה לשנת 2022. תוכלי לנצל את החופשה בחודשיים הקרובים בלבד. לאחר חודשיים תאבדי את הזכאות לחופשה'}
            ],

          vacationCyclesYears : [ 
              { key:1, 
                year:2021, 
                EntitlementId :1,
                entitlementMonths : [ 
                    {key:1,month:11,year:2021,selected:false} ,
                    {key:2,month:12,year:2021,selected:false}
                ],
                name:'זכאות 2021', 
                selected:true}

          ],

          vacationSelectedCycleYear: 2021,

          vacationSelectedCycleMonths:
          [
              {
                  "key": 1,
                  "year": 2021,
                  "month": 11,
                  "selected": false
              },
              {
                  "key": 2,
                  "year": 2021,
                  "month": 12,
                  "selected": false
              }
          ]
        }
      }
    }
    */



    getSearchHotelsForOrderMock() {
      return {

        data : {
          status:1,

          errorMsg:'',

          hotelsForOrder : [ 
              {
                key:1,
                HotelName:'בראשית',   
                HotelArea:'אילת',
                AllocationId:1, 
                RoomsNum:2, 
                TotalNights:2,
                StartVacationDateFormatted:'12/11/2021',
                EndVacationDateFormatted:'14/11/2021',
                WeekPeriodDescription :'סוף שבוע',
                NightsOnEmployee: 1,
                SupplierId:83695749,
                TotalPrice:900
              },
              {
                key:2,
                HotelName:'ישרוטל',   
                HotelArea:'אילת',
                AllocationId:2, 
                RoomsNum:2, 
                TotalNights:2,
                StartVacationDateFormatted:'12/11/2021',
                EndVacationDateFormatted:'14/11/2021',
                WeekPeriodDescription :'סוף שבוע',
                NightsOnEmployee: 0,
                SupplierId:83695749,
                TotalPrice:900
              },
              {
                key:3,
                HotelName:'מצפה הימים',   
                HotelArea:'אילת',
                AllocationId:3, 
                RoomsNum:2, 
                TotalNights:2,
                StartVacationDateFormatted:'13/11/2021',
                EndVacationDateFormatted:'15/11/2021',
                WeekPeriodDescription :'סוף שבוע',
                NightsOnEmployee: 2,
                SupplierId:83695749,
                TotalPrice:900
              },
            ]
        }
      }
    }

    

    getPersonData() {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'DataEmployeePerson/'
      //var dataObj = this.getPersonDataMock();
      var dataObj = {};

      if (window.NOFESH_SERVICE_LOGIN_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: {'EmployeeCardNum':token}
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }



    getVacationMonths() {
      
      return [
        {key:1,month:4,year:2021,name:'אפריל',selected:false},
        {key:2,month:5,year:2021,name:'מאי',selected:false},
        {key:3,month:6,year:2021,name:'יוני',selected:false},
        {key:4,month:7,year:2021,name:'יולי',selected:false}
      ]
    }



    /*
    loginUserMock() {
      return {
        data : { 
          Loggedin : "1",
          CellNumberMask : "052-11***22"
        }
      }
    }
    */






    loginUser(employeeCardNum, employeeIdNum, codeOverSms) {

      var api_action = 'Login/';
      var dataObj = {};
      // this.loginUserMock();

      

      if (window.NOFESH_SERVICE_LOGIN_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json'
          },
          data: {'EmployeeCardNum':employeeCardNum, 'EmployeeIdNum':employeeIdNum, 'codeOverSms':codeOverSms}
        });

      else  {

        console.log('loginUser - window.NOFESH_SERVICE_LIVE NO');

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }


    sendCodeSms(employeeCardNum, employeeIdNum, onceTimeCode) { 


      var api_action = 'LoginSendSms/';
      //var dataObj = this.loginUserMock();
      var dataObj = {};

      if (window.NOFESH_SERVICE_LOGIN_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json'
          },
          data: {'EmployeeCardNum':employeeCardNum, 'EmployeeIdNum':employeeIdNum, 'onceTimeCode': onceTimeCode}
        });

      else  {

        console.log('loginUser - window.NOFESH_SERVICE_LIVE NO');

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }

      
    }



    
    validateSearchHotelsForOrder(obj) {

      console.log('ValidateSearchHotelsForOrder ',obj)
      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'ValidateSearchHotelsForOrder/'
      var dataObj = {};

      if (window.NOFESH_SEARCH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json; charset=utf-8',
            'stokenauth': stoken
          },
          data: obj
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }



    getSearchHotelsForOrder(obj) {

      console.log('getSearchHotelsForOrder ',obj)
      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'SearchHotelsForOrder/'
      var dataObj = {};
      //this.getSearchHotelsForOrderMock();

      if (window.NOFESH_SEARCH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json; charset=utf-8',
            'stokenauth': stoken
          },
          data: obj
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }



    
    getSearchHotelsForOrderLastChance(obj) {

      console.log('getSearchHotelsForOrderLastChance ',obj)
      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'SearchHotelsForOrderLastChance/'
      var dataObj = {};
      //this.getSearchHotelsForOrderMock();

      if (window.NOFESH_SEARCH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json; charset=utf-8',
            'stokenauth': stoken
          },
          data: obj
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }





    placeOrder(obj) {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      console.log('NofeshService placeOrder', obj);

      var api_action = 'PlaceOrder/';

      if (window.NOFESH_SERVICE_ORDER_LIVE === 'YES') {

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: obj
        });

      } else  {

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              { test:'1'}                       
            );
          },1000);
        });
        return promise;
      }

    }



    
    placeOrderRemove(allocationId) {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 

      let obj = {'EmployeeCardNum':token, 'AllocationId':allocationId}
      var api_action = 'PlaceOrderRemove/';

      if (window.NOFESH_SERVICE_ORDER_LIVE === 'YES') {

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: obj
        });

      } else  {

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              { test:'1'}                       
            );
          },1000);
        });
        return promise;
      }

    }




    
    makeOrder(obj) {

      console.log('NofeshService makeOrder', obj);
      const {stoken} = getSToken();  
      var api_action = 'MakeOrder/';

      if (window.NOFESH_SERVICE_ORDER_LIVE === 'YES') {

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: obj
        });

      } else  {

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              { test:'1'}                       
            );
          },1000);
        });
        return promise;
      }

    }





    
    cancelOrder(orderId) {

      console.log('NofeshService CancelOrder', orderId); 
      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      
      var api_action = 'CancelOrder/';

      let data = {};
      data.EmployeeCardNum = token;
      data.orderId = orderId;
      

      if (window.NOFESH_SERVICE_ORDER_LIVE === 'YES') {

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: data
        });

      } else  {

        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              { test:'1'}                       
            );
          },1000);
        });
        return promise;
      }

    }





    getOrdersList() {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'OrdersList/'
      //var dataObj = this.getSearchHotelsForOrderMock();
      var dataObj ={};

      let data = {};
      data.EmployeeCardNum = token;

      if (window.NOFESH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: data
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }



    
    getOrderDetailsById(orderId) {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'OrderDetails/'
      var dataObj = this.getSearchHotelsForOrderMock();

      let data = {};
      data.EmployeeCardNum = token;
      data.orderId = orderId;
      //data: orderId

      if (window.NOFESH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: data
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }





    geHotelsListMock() {
      return {

        data : {

          status: "1",

          hotelsList : [
            {key:1, hotelId:1, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:2, hotelId:2, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:3, hotelId:3, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:4, hotelId:4, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:5, hotelId:5, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:6, hotelId:6, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:7, hotelId:7, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:8, hotelId:8, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:9, hotelId:9, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:10,hotelId:10,HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' }
          ]
        }
      }
    }


    
    geHotelsListFilteredMock() {
      return {

        data : {

          status: "1",

          hotelsList : [
            {key:1, hotelId:1, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:2, hotelId:2, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' },
            {key:3, hotelId:3, HotelName:'בראשית', HotelArea:'אילת', CosherType:'כשר למהדרין' ,roomsNumber:'2 חדרים', weekendOrDays:"סופ``ש", price:'100' }

          ]
        }
      }
    }


    getHotelsList() {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      let data = {};
      data.EmployeeCardNum = token;
      var api_action = 'HotelsList/'
      var dataObj = this.geHotelsListMock();

      if (window.NOFESH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          }
          ,data: data
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },3000);
        });
        return promise;
      }
    } 



    getHotelListFiltered(data) {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'HotelsFilterList/'
      var dataObj = this.geHotelsListFilteredMock();

      if (window.NOFESH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          }
          ,data: data
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },3000);
        });
        return promise;
      }
    } 



    getHotelDetailsMock() {
      return {
        data : { 
          key:1,
          hotelId:1,
          Area:'אילת',
          HotelName : 'מלון בראשית',
          HotelAddress :'רחוב התמרים 6, אילת',
          HotelPhone:'073-6584526',   
          HotelArea:'אילת',
          HotelEmail:'hotelmail@gmail.com', 
          HotelAbout:'המלון מציע חדרי אירוח נוחים עם כל הארוחות והמשקאות כלולים. תוכלו להנות ממתקנים טובים לכל המשפחה במיקום נוח קרוב מאוד לחוף.', 
          RoomType:1,
          MaxCapacityRoom:3,
          HostBase:1,
          HostChildren:true,
          StandardDetails:'',
          CosherType:'כשר למהדרין',
          HasParking:1,
          mainPic:''


        } //end data
      }
    }



    getHotelDetails(hotelId) {

      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'HotelDetails/'
      var dataObj = this.getHotelDetailsMock();

      if (window.NOFESH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json',
            'stokenauth': stoken
          },
          data: hotelId
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }



    getTotalPrice(obj) {
      
      /*
      headers: {
        'Content-Type':'application/json; charset=utf-8',
        'Authorization': `Basic ${token}`
      },*/
      console.log('getTotalPrice ',obj)
      const {token} = getToken(); 
      const {stoken} = getSToken(); 
      var api_action = 'GetTotalPrice/'
      var dataObj = 1000;

      if (window.NOFESH_SEARCH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json; charset=utf-8',
            'stokenauth': stoken
          },
          data: obj
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }


    //
    adminGetEmployeeCardNumByToken(obj) {
      
      console.log('adminGetEmployeeCardNumByToken ',obj)
      var api_action = 'AdminGetEmployeeCardNumByToken/'
      var dataObj = 1000;

      if (window.NOFESH_SEARCH_SERVICE_LIVE === 'YES')

        return axios({
          method : 'post',
          url: window.API_URL_NOFESH_SERVICE + api_action,
          headers: {
            'Content-Type':'application/json; charset=utf-8',
            'Authorization': '123456'
          },
          data: obj
        });

      else  {
        var promise = new Promise(function(resolve, reject) {
          setTimeout(() => {
            resolve(    
              dataObj                      
            );
          },1000);
        });
        return promise;
      }
    }


}